<template>
  <v-card>
    <v-card-title class="py-3">
      <h3 class="pt-0 text-center">
        Thông tin học sinh đăng ký Ielts conversation
      </h3>
    </v-card-title>
    <v-card>
      <v-tabs v-model="tab">
        <template v-for="(item, index) in listChild">
          <v-tab
            :key="item.id"
            v-if="item.vhUserId && checkChildHaveData(item.vhUserId)"
            @click="changeChild(item.vhUserId)"
            :value="index"
            >{{ item.fullName }}</v-tab
          >
        </template>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <template v-for="item in listChild">
          <v-tab-item
            :key="item.id"
            v-if="item.vhUserId && checkChildHaveData(item.vhUserId)"
          >
            <v-simple-table v-if="item.vhUserId" class="px-3 py-1">
              <thead>
                <tr>
                  <th class="text-center">Độ tuổi đã chọn</th>
                  <th class="text-center">Mục tiêu đã chọn</th>
                  <th class="text-center">Level hệ thống lựa chọn</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="selectedChild">
                  <td class="text-center">{{ selectedChild.chosenLevel }}</td>
                  <td class="text-center">
                    {{ selectedChild.chosenGoals.join(", ") }}
                  </td>
                  <td class="text-center">
                    Level {{ selectedChild.suggestedLevel }}
                  </td>
                </tr>
                <tr v-else>
                  <td colspan="3" class="text-center">Không có dữ liệu</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
        </template>
      </v-tabs-items>
    </v-card>
  </v-card>
</template>

<script>
import RepositoryFactory from "../../../repositories/RepositoryFactory";
const ContactRepository = RepositoryFactory.get("contact");

export default {
  props: {
    listChild: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      tab: 0,
      dataOnboardingIelts: [],
      selectedChild: null,
    };
  },
  async created() {
    await this.getDataOnboardingIelts();
  },
  methods: {
    checkChildHaveData(userId) {
      const data = this.dataOnboardingIelts.find(
        (item) => item.userId === userId
      );
      return data ? true : false;
    },
    changeChild(userId) {
      if (!userId) {
        this.selectedChild = null;
        return;
      }
      this.selectedChild = this.dataOnboardingIelts.find(
        (item) => item.userId === userId
      );
    },
    async getDataOnboardingIelts() {
      const userIds = this.listChild
        .filter((item) => item.vhUserId)
        .map((item) => item.vhUserId);
      if (userIds.length === 0) return;
      const res = await ContactRepository.getContactIeltOnboarding({ userIds });
      if (res && res.data) {
        this.dataOnboardingIelts = res.data;
        userIds.forEach((element) => {
          const data = this.dataOnboardingIelts.find(
            (item) => item.userId === element
          );
          if (data) {
            this.selectedChild = data;
            return;
          }
        });
      }
    },
  },
};
</script>

<style>
</style>